(function () {
  'use strict';

  const ZOOM_SCALE   = 2.5;
  const MOBILE_BREAK = 768;

  // ─── State ────────────────────────────────────────────────────────────────

  let zoomedSlide = null;
  let zoomedImg   = null;

  // ─── Helpers ──────────────────────────────────────────────────────────────

  function isMobile() {
    return window.innerWidth < MOBILE_BREAK;
  }

  function getGallery() {
    return document.querySelector('media-gallery');
  }

  function getSlideImg(slide) {
    return slide.querySelector('img.product-media__image, img[srcset], img[src]') || null;
  }

  // ─── CSS ──────────────────────────────────────────────────────────────────

  function injectCSS() {
    if (document.getElementById('vmz-style')) return;
    const s = document.createElement('style');
    s.id = 'vmz-style';
    s.textContent = `
      @media (min-width: 768px) {
        slideshow-slide.vmz-ready {
          cursor: zoom-in !important;
        }
        slideshow-slide.vmz-ready * {
          cursor: zoom-in !important;
        }
        slideshow-slide.vmz-zoomed {
          overflow: hidden !important;
          cursor: zoom-out !important;
        }
        slideshow-slide.vmz-zoomed * {
          cursor: zoom-out !important;
          pointer-events: none !important;
        }
        slideshow-slide.vmz-zoomed img.vmz-img {
          transform-origin: 0 0;
          will-change: transform;
          user-select: none;
          transition: none;
        }
        slideshow-slide.vmz-ready [data-zoom-button],
        slideshow-slide.vmz-ready .product-media__zoom-button,
        slideshow-slide.vmz-ready button[aria-label*="zoom" i],
        slideshow-slide.vmz-ready button[aria-label*="Open" i] {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(s);
  }

  // ─── Zoom activate / deactivate ───────────────────────────────────────────

  function activateZoom(slide, e) {
    const img = getSlideImg(slide);
    if (!img) return;
    zoomedSlide = slide;
    zoomedImg   = img;
    img.classList.add('vmz-img');
    slide.classList.remove('vmz-ready');
    slide.classList.add('vmz-zoomed');
    panZoom(slide, img, e);
  }

  function deactivateZoom() {
    if (!zoomedSlide || !zoomedImg) return;
    zoomedImg.style.transform = '';
    zoomedImg.classList.remove('vmz-img');
    zoomedSlide.classList.remove('vmz-zoomed');
    zoomedSlide.classList.add('vmz-ready');
    zoomedSlide = null;
    zoomedImg   = null;
  }

  function panZoom(slide, img, e) {
    const rect = slide.getBoundingClientRect();
    const fx = Math.min(1, Math.max(0, (e.clientX - rect.left)  / rect.width));
    const fy = Math.min(1, Math.max(0, (e.clientY - rect.top)   / rect.height));
    const maxX = rect.width  * (ZOOM_SCALE - 1);
    const maxY = rect.height * (ZOOM_SCALE - 1);
    img.style.transform = `scale(${ZOOM_SCALE}) translate(${-(fx * maxX) / ZOOM_SCALE}px, ${-(fy * maxY) / ZOOM_SCALE}px)`;
  }

  // ─── Attach handlers to a single slide ───────────────────────────────────

  function attachToSlide(slide) {
    // Skip video slides
    if (slide.querySelector('video, deferred-media')) return;

    // Always re-add vmz-ready class (morph wipes it) even if handlers
    // are already bound — classList.add is idempotent
    slide.classList.add('vmz-ready');

    // Only bind event listeners once
    if (slide.dataset.vmzAttached) return;
    slide.dataset.vmzAttached = 'true';

    slide.addEventListener('click', (e) => {
      if (isMobile()) return;
      if (e.target.closest('video, [data-media-type="external_video"]')) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      if (zoomedSlide === slide) {
        deactivateZoom();
      } else {
        if (zoomedSlide) deactivateZoom();
        activateZoom(slide, e);
      }
    }, true);

    slide.addEventListener('mousemove', (e) => {
      if (zoomedSlide !== slide) return;
      panZoom(slide, zoomedImg, e);
    });

    slide.addEventListener('mouseleave', () => {
      if (zoomedSlide === slide) deactivateZoom();
    });
  }

  // ─── Re-attach to all slides (safe to call multiple times) ───────────────

  function attachToAllSlides() {
    const gallery = getGallery();
    if (!gallery) return;
    // Deactivate any active zoom first — its slide may have been morphed
    deactivateZoom();
    gallery.querySelectorAll('slideshow-slide').forEach(attachToSlide);
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function init() {
    injectCSS();
    attachToAllSlides();

    // variant:update fires AFTER Horizon's morph completes — perfect time
    // to re-apply vmz-ready and re-bind any new slides.
    // This is the same event our variant-media-filter.js uses.
    document.addEventListener('variant:update', () => {
      // Small rAF delay to let morph finish painting before we query slides
      requestAnimationFrame(() => attachToAllSlides());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();